import fetch from 'isomorphic-fetch';
import {commonErrorHandler, commonHeaders} from '../actions/fetch.util';

export const PAYMENT_CANCEL_REQUESTS_REQUEST = 'PAYMENT_CANCEL_REQUESTS_REQUEST';
export const PAYMENT_CANCEL_REQUESTS_RESPONSE = 'PAYMENT_CANCEL_REQUESTS_RESPONSE';

function paymentCancelRequestsRequest() {
  return {
    type: PAYMENT_CANCEL_REQUESTS_REQUEST,
  };
}

function paymentCancelRequestsResponse(paymentCancelRequests) {
  return {
    type: PAYMENT_CANCEL_REQUESTS_RESPONSE,
    paymentCancelRequests,
  };
}

export function createPaymentCancelRequest(entitlementId, reason, history) {
  fetch(`${API_URL}/payment-cancel-requests/current-user?entitlementId=${entitlementId}&reason=${encodeURI(reason)}`, {
    method: 'POST',
    headers: commonHeaders(),
  })
    .then(commonErrorHandler)
    .then(() => {
      alert('결제 취소 요청이 접수됐습니다.');
      history.push('/my-pc-bang/usage-status/refund');
    })
    .catch(() => alert('결제 취소 요청에 실패했습니다.'));
}

export function fetchPaymentCancelRequestsForCurrentUser() {
  return dispatch => {
    dispatch(paymentCancelRequestsRequest());
    fetch(`${API_URL}/payment-cancel-requests/current-user`, {
      method: 'GET',
      headers: commonHeaders(),
    })
      .then(response => commonErrorHandler(response))
      .then(response => response.json())
      .then(refundableEntitlements => {
        dispatch(paymentCancelRequestsResponse(refundableEntitlements));
      });
  };
}
